import { CommitmentDetail } from '@/api/commitment';
import { ActionButtons, FreezeBtn } from '../UtxoDetailsStyle';
import { LockOutlined, UnlockOutlined } from '@ant-design/icons';
import React from 'react';
import { freezeCommitment, waitForFreezeApiTransaction } from '@/api/freeze';
import { SupportedChainId, SupportedChainMap } from '@packet/constants/AppSupportChains';
import { message, Modal } from 'antd';
import { waitForTransactionReceipt } from 'viem/actions';
import { createPublicClient, http } from 'viem';

export const FreezeButton: React.FC<{ utxo: CommitmentDetail; chainId: SupportedChainId; onSuccess: () => any }> = ({ utxo, chainId, onSuccess }) => {
  if (utxo.is_spent) return null;
  const action = utxo.is_frozen ? 'Thaw' : 'Freeze';
  const freeze = async () => {
    const confirm = Modal.confirm({
      title: `Confirm ${action}`,
      content:
        action === 'Freeze'
          ? 'Are you sure you want to freeze this UTXO? This will temporarily disable it from being spent until you thaw it.'
          : 'Are you sure you want to thaw this UTXO? This will make it available for spending again.',
      okText: action,
      cancelButtonProps: { disabled: false },
      onOk: async () => {
        const res = await freezeCommitment(chainId, utxo.commitment);
        if (res.code || !res.data) return message.error(res.message);
        confirm.update({ cancelButtonProps: { disabled: true } });
        const hash = await waitForFreezeApiTransaction(chainId, res.data);
        if (!hash) return message.error(`${action} failed`);
        const client = createPublicClient({ chain: SupportedChainMap[chainId], transport: http() });
        await waitForTransactionReceipt(client, { hash });
        message.success(`${action} Success`);
        await onSuccess();
      },
    });
  };

  return (
    <ActionButtons>
      <FreezeBtn onClick={freeze}>
        {utxo.is_frozen ? <UnlockOutlined /> : <LockOutlined />}
        {action}
      </FreezeBtn>
    </ActionButtons>
  );
};
